var Role;
(function (Role) {
    Role[Role["KpmgAdmin"] = 1] = "KpmgAdmin";
    Role[Role["ClientAdmin"] = 2] = "ClientAdmin";
    Role[Role["Universal"] = 3] = "Universal";
    Role[Role["Verifier"] = 4] = "Verifier";
    Role[Role["Approver"] = 5] = "Approver";
    Role[Role["Watcher"] = 6] = "Watcher";
    Role[Role["Creator"] = 7] = "Creator";
})(Role || (Role = {}));
export default Role;
